import { getProxiedServiceUrl } from 'wmic-portals-url-js';
import { JsonRPCService } from '@xengage/gw-portals-transport-js';

export default class PolicyDiffService {
    static getPolicyDiffWithPrevious(data, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('policydiff'), 'getPolicyDiffWithPrevious', [data], additionalHeaders);
    }
}
